import { render } from "./modalSendLinkPerson.vue?vue&type=template&id=4c85ca75"
import script from "./modalSendLinkPerson.vue?vue&type=script&lang=js"
export * from "./modalSendLinkPerson.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__